var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"rounded-lg",staticStyle:{"cursor":"auto"},attrs:{"tile":_vm.tile,"color":_vm.color,"rounded":_vm.rounded,"hover":_vm.hover,"flat":_vm.flat,"loading":_vm.loading,"elevation":Number.parseInt(_vm.elevation),"outlined":_vm.outlined,"max-height":_vm.maxheight,"max-width":_vm.maxwidth}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }